<template>
  <div class="min-h-screen flex flex-col gradient-bg">
    <!-- 主区域 = 视口高度 − 页脚；滚动只发生在此层，备案条始终在首屏底部可见 -->
    <div class="flex-1 min-h-0 w-full overflow-y-auto">
      <router-view />
    </div>
    <footer class="shrink-0 py-4 px-4 text-center text-sm text-gray-500 flex flex-wrap items-center justify-center gap-x-2 gap-y-2">
      <!-- 二维码 absolute，仅占「联系我们」宽度，不挤压右侧备案号 -->
      <div
        class="relative inline-block select-none"
        @mouseenter="showContactWechatQr = true"
        @mouseleave="showContactWechatQr = false"
      >
        <div
          v-show="showContactWechatQr"
          class="absolute bottom-full left-1/2 z-50 flex max-w-[min(100vw-1rem,424px)] -translate-x-1/2 flex-col-reverse items-center gap-1"
          role="tooltip"
        >
          <div class="h-2 w-40 max-w-full shrink-0" aria-hidden="true" />
          <div class="w-full rounded-xl border border-gray-200 bg-white p-3 shadow-xl">
            <img
              :src="contactWechatImg"
              alt="微信二维码"
              class="mx-auto aspect-square object-contain w-[min(400px,calc(100vw-3rem))]"
              width="400"
              height="400"
              loading="lazy"
            />
            <p class="mt-2 text-xs text-gray-600 text-center whitespace-nowrap">添加微信好友</p>
          </div>
        </div>
        <span
          class="relative cursor-default border-b border-dotted border-gray-400 text-gray-500 hover:text-gray-700 hover:border-gray-600 transition-colors"
        >
          联系我们
        </span>
      </div>
      <span class="text-gray-400" aria-hidden="true">|</span>
      <a
        href="https://beian.miit.gov.cn/"
        target="_blank"
        rel="noopener noreferrer"
        class="hover:text-gray-700 transition-colors"
      >京ICP备15062621号-2</a>
    </footer>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useRoute } from 'vue-router'
import { useHead } from '@vueuse/head'
import contactWechatImg from './assets/img/contact_wechat.png'
import { SITE_URL, DEFAULT_META, ROUTE_META } from './utils/seo'

const showContactWechatQr = ref(false)

const route = useRoute()

const meta = computed(() => {
  const path = route.path === '/' ? '/single' : route.path
  const routeMeta = ROUTE_META[path] || {}
  const title = routeMeta.title || DEFAULT_META.title
  const description = routeMeta.description || DEFAULT_META.description
  const canonical = path !== '/' ? `${SITE_URL}${path}` : `${SITE_URL}/single`
  return {
    title,
    meta: [
      { name: 'description', content: description },
      { name: 'keywords', content: DEFAULT_META.keywords },
      { property: 'og:title', content: title },
      { property: 'og:description', content: description },
      { property: 'og:url', content: canonical },
      { name: 'twitter:title', content: title },
      { name: 'twitter:description', content: description }
    ],
    link: [
      { rel: 'canonical', href: canonical }
    ]
  }
})

useHead(meta)
</script>